import {captureMessage} from "@sentry/react";
import {Team} from "../../../../lib/src/api";

/**
 * Resolve all child teams recursively. Use maxRecursion to prevent crashed with looping team structures.
 * @param teams
 * @param parentTeamId
 * @param maxRecursion
 */
export function getSubTeamsRecursively(teams: Team[], parentTeamId: number, maxRecursion = 40): Team[] {
  if (maxRecursion < 0) {
    console.warn('Reached maximum recursion in getTeamChildrenRecursively')
    captureMessage('Reached maximum recursion in getTeamChildrenRecursively', 'warning')
    return []
  }
  const directChildren = teams.filter(c => c.parentObjectId === parentTeamId)
  return [
    ...directChildren,
    ...directChildren.map((childTeam) => getSubTeamsRecursively(teams, childTeam.id, maxRecursion - 1)).flat()
  ]
}

/**
 * Resolve all parent teams recursively. Use maxRecursion to prevent crashed with looping team structures.
 * @param teams
 * @param teamId
 * @param maxRecursion
 */
export function getParentTeamsRecursively(teams: Team[], teamId: number, maxRecursion = 40): Team[] {
  if (maxRecursion < 0) {
    console.warn('Reached maximum recursion in getTeamChildrenRecursively')
    captureMessage('Reached maximum recursion in getTeamChildrenRecursively', 'warning')
    return []
  }
  const currentTeam = teams.find(t => t.id === teamId)
  if (! currentTeam) {
    return []
  }
  const parent = teams.find(t => t.id === currentTeam?.parentObjectId)
  if (! parent) {
    return []
  }

  return [
    parent,
    ...getParentTeamsRecursively(teams, parent.parentObjectId, maxRecursion),
  ]
}
